import { useParams } from 'react-router-dom'
import { ExecutionDetail } from '../components/execution-history/ExecutionDetail'
import { ExecutionList } from '../components/execution-history/ExecutionList'

/**
 * Execution History (Ship's Log) — the run grain.
 *
 * `/execution-history` lists every ETL run (Etl.EtlRun) with its filters in the
 * URL; `/execution-history/:runId` is one run in full, whose entity rows open
 * in the ETL Explorer (`/etl-explorer/:entityRunId`, the entity grain). Served
 * by GET api/observatory/executions, plain [Authorize], read-only.
 */
export function ExecutionHistoryPage() {
  const { runId } = useParams<{ runId: string }>()

  // Keyed on the id, so moving between runs never shows one run's state under another's header.
  return runId ? <ExecutionDetail key={runId} runId={runId} /> : <ExecutionList />
}
